import { AppLayout } from './components/layout/AppLayout.js'
import { SetupGate } from './components/setup/SetupGate.js'
import { ClockViewer } from './components/clock/ClockViewer.js'

export default function App() {
  if (window.location.pathname.startsWith('/clock/')) return <ClockViewer />
  return <SetupGate><AppLayout /></SetupGate>
}
